import { BlockStack, Card, Text, TextField } from '@shopify/polaris';
import React from 'react';
import { useLocation } from 'react-router-dom';
const Name = ({ fields }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.includes("admin");
  return (
    <Card>
      <BlockStack gap={200}>
        <BlockStack gap={200}>
          <Text>First name</Text>
          <TextField
            disabled={isAdmin}
            {...fields.first_name}
          />
        </BlockStack>
        <BlockStack gap={200}>
          <Text>Last name</Text>
          <TextField
            disabled={isAdmin}
            {...fields.last_name}
          />
        </BlockStack>
      </BlockStack>
    </Card>
  )
}

export default Name;